// extracted by mini-css-extract-plugin
module.exports = {"root":"TaskHeadPriority_root__3iqUr","title":"TaskHeadPriority_title__1za-N"};